module.exports = __webpack_public_path__ + "img/test_main.ffc6d7bc.png";